var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"icon":_vm.icon,"type":_vm.type,"loading":_vm.loading,"disabled":!_vm.hasPerms(_vm.perms)},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }